import { Component, Input, Output, EventEmitter, OnDestroy, OnInit, OnChanges, SimpleChanges } from '@angular/core'
import { FormControl, ReactiveFormsModule } from '@angular/forms'
import { Editor, NgxEditorModule, Toolbar, schema } from 'ngx-editor'
import { Schema } from 'prosemirror-model'
import { Subscription } from 'rxjs'
import { CustomToolbarComponent } from './custom-toolbar.component/custom-toolbar.component'
import { createPlaceholderPlugin, placeholderNodeSpec } from './custom-toolbar.component/placeholder-plugin'
import { createPasteHandlerPlugin } from './paste-handler'

@Component({
  selector: 'app-formatted-text-editor',
  imports: [NgxEditorModule, ReactiveFormsModule, CustomToolbarComponent],
  templateUrl: './formatted-text-editor.component.html',
  styleUrl: './formatted-text-editor.component.scss',
})
export class FormattedTextEditorComponent implements OnInit, OnChanges, OnDestroy {
  @Input()
  initialContent: any | null

  @Input()
  allowPlaceholders: boolean = true

  @Input()
  displayToolbar: boolean = true

  @Input()
  autoFocus: boolean = true

  @Output()
  contentChange = new EventEmitter<any>()

  editor!: Editor
  editorControl!: FormControl
  private valueChangesSubscription: Subscription | null = null

  toolbar: Toolbar = [
    ['bold', 'italic', 'underline'],
    ['ordered_list', 'bullet_list'],
  ]

  ngOnInit(): void {
    const customSchema = new Schema({
      nodes: schema.spec.nodes.addBefore('image', 'placeholder', placeholderNodeSpec),
      marks: schema.spec.marks,
    })

    this.editor = new Editor({
      schema: customSchema,
      plugins: [createPlaceholderPlugin(), createPasteHandlerPlugin()],
    })

    const initialValue = this.initialContent

    this.editorControl = new FormControl({
      value: initialValue,
      disabled: false,
    })

    this.valueChangesSubscription = this.editorControl.valueChanges.subscribe((value) => {
      this.contentChange.emit(value)
    })

    if (this.autoFocus) {
      setTimeout(() => this.editor.view.focus(), 0)
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    const initialContentChange = changes['initialContent'] ?? null
    if (initialContentChange !== null && !changes['initialContent'].firstChange) {
      const newValue = changes['initialContent'].currentValue
      if (JSON.stringify(this.editorControl.value) !== JSON.stringify(newValue)) {
        this.editorControl.setValue(newValue, { emitEvent: false })
      }
    }
  }

  ngOnDestroy(): void {
    this.valueChangesSubscription?.unsubscribe()
    this.editor.destroy()
  }
}
